import { Credit } from "src/shared/models/credit.model";

export const CreditSerializer = {
  fromJson(json: any): Credit {
    return new Credit(json);
  },

  fromJsonList(json: any[]): Credit[] {
    return json.map((item) => new Credit(item));
  },
};
